<template>
    <InformeCard id="invitaciones_agrupadas" name="invitaciones_agrupadas" collapsable="true" title="Invitaciones agrupadas">
        <div class="table-responsive">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>TIPO DE PRECIO</th>
                        <th>LOCALIZACIÓN</th>
                        <th>CONCEPTO</th>
                        <th>ENTREGADAS</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(venta, index) in informe">
                        <tr v-if="venta.price == 0" :key="index">
                            <td>{{ venta.description }}</td>
                            <td>{{ venta.place_section_name || venta.place_section_plaza_name || venta.region_name || venta.region_plaza_name || venta.sector_name || '' }}</td>
                            <td>{{ venta.concepto }}</td>
                            <td>{{ venta.total }}</td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="3">TOTAL</td>
                        <td>{{ countTotal() }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id', 'informe'],
        methods: {
            countTotal() {
                var total = 0;
                for (var i = 0; i < this.informe.length; i++) {
                    if(this.informe[i].metodo_pago == 6 || this.informe[i].metodo_pago == 10) {
                        total = total + this.informe[i].total;
                    }
                }

                return total;
            }
        },
        components: {
            InformeCard,
        }
    }
</script>
